var module = angular.module('octopusApp.infrastructure');

module.directive('searchBox', function($timeout) {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
      inputText: '=',
      placeholder: '@',
      onTextChanged: '=',
      onSearchClicked: '=',
      autoFocus: '='
    },
    templateUrl: 'infrastructure/directives/views/search-box.html'
 };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/search-box.js
// module id = 680
// module chunks = 1